export default __webpack_public_path__ + "static/renter-landing-48bb9b305e137441590834684c9dc8f8.jpg";